import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="110" height="74" viewBox="0 0 110 74">
    <g id="Group_1" data-name="Group 1" transform="translate(-233 -203)">
      <text
        id="AB"
        transform="translate(233 263)"
        fill="#64ffda"
        fontSize="60"
        fontFamily="SFMono-Medium, SF Mono"
        fontWeight="500">
        <tspan x="0" y="0">
          AB
        </tspan>
      </text>
      <line
        id="Line_1"
        data-name="Line 1"
        x2="71"
        transform="translate(233.5 270.5)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"></line>
      <text
        id="e"
        transform="translate(305 260)"
        fill="#64ffda"
        fontSize="60"
        fontFamily="SFMono-Medium, SF Mono"
        fontWeight="500">
        <tspan x="0" y="0">
          e
        </tspan>
      </text>
    </g>
  </svg>
);

export default IconLogo;
